// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__22kxx","actions":"Section_actions__2zFwG","count":"Section_count__2skLn","name":"Section_name__w7mPT"};